module.exports = __webpack_public_path__ + "static/media/4.9dd40a8e.svg";